import { ActionContext, ActionTree, GetterTree } from "vuex";
import { CouponData } from "@/model/Coupon";
import { deepCopy } from "@/service/util"; // 2021-05-31 sh add

const initialState: CouponData = {
  coupon: {
    subTotalZn: 0,
    subTotalZk: 0
  },
  proposal: {},
  tokuten: {},
  isConfirm: 0
};
const actions: ActionTree<CouponData, any> = {
  setCoupon(
    { commit }: ActionContext<CouponData, any>,
    payload: CouponData
  ): void {
    commit("setCoupon", payload);
  },
  confirm({ commit }: ActionContext<CouponData, any>, payload: number): void {
    commit("confirm", payload);
  },
  clearState({ commit }: ActionContext<CouponData, any>): void {
    commit("clearState");
  },
  updateSubTotal({ commit }: ActionContext<CouponData, any>, payload: any): void {
    commit("updateSubTotal", payload);
  }
};

const mutations = {
  setCoupon(state: CouponData, payload: CouponData) {
    if (payload.coupon && payload.coupon.items) {
      payload.coupon.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? 1 : 0)
      );
    }
    if (payload.proposal && payload.proposal.items) {
      payload.proposal.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? 1 : 0)
      );
    }
    if (payload.tokuten && payload.tokuten.items) {
      payload.tokuten.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? 1 : 0)
      );
    }
    /** 2021-05-31 sh #7126 fix add manual input [START] */
    state.couponOld = deepCopy(state.coupon);
    /** 2021-05-31 sh #7126 fix add manual input [END] */
    Object.assign(state, payload);
  },
  confirm(state: CouponData, payload: number) {
    state.isConfirm = payload;
  },
  clearState(state: CouponData) {
    Object.assign(state, { ...initialState });
  },
  updateSubTotal(state: CouponData, payload: any) {
    if (state.coupon) {
      state.coupon.subTotalZk = payload.subTotalZk;
      state.coupon.subTotalZn = payload.subTotalZn;
    }
  }
};

const getters: GetterTree<CouponData, any> = {
  hasData(state: CouponData) {
    if (state.coupon && state.coupon.items) {
      return true;
    }
    return false;
  },
  currentState(state: CouponData) {
    if (state.coupon && state.coupon.items) {
      state.coupon.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? 1 : 0)
      );
    }
    if (state.proposal && state.proposal.items) {
      state.proposal.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? 1 : 0)
      );
    }
    if (state.tokuten && state.tokuten.items) {
      state.tokuten.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? 1 : 0)
      );
    }
    return state;
  },
  currentStateForShow(state: CouponData) {
    if (state.coupon && state.coupon.items) {
      state.coupon.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? true : false)
      );
    }
    if (state.proposal && state.proposal.items) {
      state.proposal.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? true : false)
      );
    }
    if (state.tokuten && state.tokuten.items) {
      state.tokuten.items.map(
        (e: any) => (e.isCheck = e.isCheck === true || e.isCheck === 1 ? true : false)
      );
    }
    return state;
  },
  total(state: CouponData) {
    if (state.coupon) {
      const { subTotalZn, subTotalZk, items } = state.coupon;
      return { subTotalZn, subTotalZk, isConfirm: state.isConfirm, items };
    }
    return null;
  },
  isConfirm(state: CouponData) {
    return state.isConfirm;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
